const transformUrlWatchToEmbed = (url) => {
  if (url) return url.replace("watch?v=", "embed/");
  return "";
};

const transformUrlSortLinkToEmbed = (url) => {
  let videoID = "";
  if (url.includes("youtu.be")) {
    videoID = url.split("youtu.be/")[1];
  } else if (url.includes("shorts")) {
    videoID = url.split("shorts/")[1];
  }
  return `https://www.youtube.com/embed/${videoID}`;
};

const transformUrlChannel = (url) => {
  const urlSearchParams = new URLSearchParams(url);
  const params = Object.fromEntries(urlSearchParams.entries());
  const videoID = params[Object.keys(params)[0]];
  return `https://www.youtube.com/embed/${videoID}`;
};

const checkVideoUrlFormat = (url) => {
  let transformedUrl = "";
  if (url?.includes("channel")) {
    transformedUrl = transformUrlChannel(url);
  } else if (url?.includes("watch")) {
    transformedUrl = transformUrlWatchToEmbed(url);
  } else if (url?.includes("youtu.be") || url?.includes("shorts")) {
    transformedUrl = transformUrlSortLinkToEmbed(url);
  } else if (url?.startsWith("-")) {
    transformedUrl = "";
  } else {
    transformedUrl = url;
  }
  return transformedUrl;
};

export default checkVideoUrlFormat;
